// Destructive-confirmation dialog (mirrors solya-app's ConfirmDialog).

import { Button } from "./primitives.js"

export function ConfirmDialog({
  open,
  title,
  message,
  confirmText,
  cancelText,
  submitting = false,
  onConfirm,
  onClose
}: {
  open: boolean
  title: string
  message: string
  confirmText: string
  cancelText: string
  submitting?: boolean
  onConfirm: () => void
  onClose: () => void
}) {
  if (!open) return null
  return (
    <div className="dialog__scrim">
      <div className="dialog" role="alertdialog" aria-label={title}>
        <h2 className="dialog__title">{title}</h2>
        <p className="muted">{message}</p>
        <div className="dialog__actions">
          <Button variant="ghost" onClick={onClose} disabled={submitting}>
            {cancelText}
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={submitting}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  )
}
